import { render, staticRenderFns } from "./GoodsIssueCreateView.vue?vue&type=template&id=4850c77e"
import script from "./GoodsIssueCreateView.vue?vue&type=script&lang=js"
export * from "./GoodsIssueCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports